define('OutSystems/ReactWidgets/Label',["require", "exports", "tslib", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, HtmlTags_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Label = void 0;
    var Label = (function (_super) {
        tslib_1.__extends(Label, _super);
        function Label() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Label.prototype.render = function () {
            var labelAttributes = {
                "data-label": "",
                className: this.props.style,
                htmlFor: this.getSiblingWidgetId(this.props.targetWidget),
            };
            if (this.props.mandatory) {
                labelAttributes.className =
                    (labelAttributes.className === undefined ? "" : labelAttributes.className + " ") + "mandatory";
            }
            if (this.props.gridProperties && this.props.gridProperties.width) {
                labelAttributes.className =
                    (labelAttributes.className === undefined ? "" : labelAttributes.className + " ") + "OSInline";
            }
            this.fillWithBuiltinProperties(labelAttributes);
            return React.createElement(HtmlTags_1.HtmlTags.label, labelAttributes, this.props.children);
        };
        Label = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Label);
        return Label;
    }(Widget_1.Widget));
    exports.Label = Label;
});
//# sourceMappingURL=Label.js.map;
